import React from "react";

import { BrowserRouter } from "react-router";
import { MaterialUIControllerProvider } from "context";

import ReactDOM from "react-dom/client";

// Material Dashboard 2 PRO React Context Provider
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter
    future={{
      v7_relativeSplatPath: true,
    }}
  >
    <MaterialUIControllerProvider>
      <App />
    </MaterialUIControllerProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
